/// <reference path="../../node_modules/jquery-validation/dist/jquery.validate.js" />
/// <reference path="vendor/sticky_js/jquery.sticky.js" />

(function($) {
    $("form.js_formValidate").validate();
})(jQuery);